import { useCallback } from 'react';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
export const useDrawTagCircle = (tag, offset) => useCallback((graphics) => {
    if (!(tag === null || tag === void 0 ? void 0 : tag.color)) {
        return;
    }
    graphics.clear();
    graphics.beginFill(hexStringToNumber(tag.color));
    graphics.drawCircle(offset.x, offset.y, 5);
    graphics.endFill();
}, [tag, offset.x, offset.y]);
